import { z } from 'zod';
import {
  KsInvestmentPinpointFieldEnum,
  type KsInvestmentPinpointMappingType,
} from '../utils/ks-investment-pinpoint';
import {
  type KsLocalGovernmentMultiplePinpointMappingType,
  KsLocalGovernmentPinpointFieldEnum,
  type KsLocalGovernmentPinpointMappingType,
  KsLocalGovernmentPinpointMultipleFieldEnum,
} from '../utils/ks-local-government-pinpoint';
import {
  type KsStandardMultiplePinpointMappingType,
  KsStandardPinpointFieldEnum,
  type KsStandardPinpointMappingType,
  KsStandardPinpointMultipleFieldEnum,
} from '../utils/ks-standard-pinpoint';
import {
  type RsMultiplePinpointMappingType,
  RsPinpointFieldEnum,
  type RsPinpointMappingType,
  RsPinpointMultipleFieldEnum,
} from '../utils/rs-pinpoint';
import {
  type RsSkippedReviewMultiplePinpointMappingType,
  RsSkippedReviewPinpointFieldEnum,
  type RsSkippedReviewPinpointMappingType,
  RsSkippedReviewPinpointMultipleFieldEnum,
} from '../utils/rs-skipped-review-pinpoint';
import {
  type SsMultiplePinpointMappingType,
  SsPinpointFieldEnum,
  type SsPinpointMappingType,
  SsPinpointMultipleFieldEnum,
} from '../utils/ss-pinpoint';
import { PartialPinpointPathModel } from './pinpoint-path';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

export const PinpointFieldEnum = z.enum([
  ...RsPinpointFieldEnum.options,
  ...RsSkippedReviewPinpointFieldEnum.options,
  ...SsPinpointFieldEnum.options,
  ...KsInvestmentPinpointFieldEnum.options,
  ...KsStandardPinpointFieldEnum.options,
  ...KsLocalGovernmentPinpointFieldEnum.options,
]);
type PinpointFieldEnumType = z.infer<typeof PinpointFieldEnum>;

export const PinpointMultipleFieldEnum = z.enum([
  ...RsPinpointMultipleFieldEnum.options,
  ...SsPinpointMultipleFieldEnum.options,
  ...RsSkippedReviewPinpointMultipleFieldEnum.options,
  ...KsLocalGovernmentPinpointMultipleFieldEnum.options,
  ...KsStandardPinpointMultipleFieldEnum.options,
]);

export const pinpointStartMatchTargetFields = [
  'rs.activity',
  'ss.activity',
  'ks.standard.activity',
  'ks.local-government.activity',
  'rs.indicator-title',
  'rs.indicator-description',
  'rs.activity-and-result-target',
  'rs.achievement-for-qualitative-outcome',
  'rs.indicator-setting-reason',
  'rs.reason-for-setting-qualitative-outcome',
  'rs.reason-why-outcomes-cannot-be-multiple',
  'rs.connection-to-next-outcome',
  'ss.indicator-title',
  'ss.indicator-description',
  'ss.activity-and-result-target',
  'ss.achievement-for-qualitative-outcome',
  'ss.indicator-setting-reason',
  'ss.reason-for-setting-qualitative-outcome',
  'ss.reason-why-outcomes-cannot-be-multiple',
  'ss.connection-to-next-outcome',
  'ks.local-government.indicator-title',
  'ks.local-government.indicator-description',
  'ks.local-government.activity-and-result-target',
  'ks.local-government.achievement-for-qualitative-outcome',
  'ks.local-government.indicator-setting-reason',
  'ks.local-government.reason-for-setting-qualitative-outcome',
  'ks.local-government.reason-why-outcomes-cannot-be-multiple',
  'ks.local-government.connection-to-next-outcome',
  'ks.standard.indicator-title',
  'ks.standard.indicator-description',
  'ks.standard.activity-and-result-target',
  'ks.standard.achievement-for-qualitative-outcome',
  'ks.standard.indicator-setting-reason',
  'ks.standard.reason-for-setting-qualitative-outcome',
  'ks.standard.reason-why-outcomes-cannot-be-multiple',
  'ks.standard.connection-to-next-outcome',
] satisfies PinpointFieldEnumType[];

export const PinpointModel = z.object({
  /** 画面ごとに必要なパラメータ */
  path: PartialPinpointPathModel,
  /**
   * フィールド単位の分類
   * 過去の遺産がある場合にzodで落ちないようにするためにここはstringにしている
   */
  field: z.string(),
}) as z.ZodType<PinpointMappingType>;

export type PinpointMappingType =
  | RsPinpointMappingType
  | RsSkippedReviewPinpointMappingType
  | SsPinpointMappingType
  | KsInvestmentPinpointMappingType
  | KsStandardPinpointMappingType
  | KsLocalGovernmentPinpointMappingType;

export type PinpointMultipleMappingType =
  | RsMultiplePinpointMappingType
  | RsSkippedReviewMultiplePinpointMappingType
  | SsMultiplePinpointMappingType
  | KsLocalGovernmentMultiplePinpointMappingType
  | KsStandardMultiplePinpointMappingType;
